import React, { useEffect, useState } from 'react';
import { api, errText } from '../api.js';

export default function AdminRestaurants() {
  const [list, setList] = useState(null);
  const [plans, setPlans] = useState([]);
  const [q, setQ] = useState('');
  const [err, setErr] = useState('');

  const load = (query = '') =>
    api(`/api/admin/restaurants${query ? `?q=${encodeURIComponent(query)}` : ''}`)
      .then(setList)
      .catch((e) => setErr(errText(e)));

  useEffect(() => {
    load();
    api('/api/admin/plans').then((d) => setPlans(d.plans)).catch(() => {});
  }, []);

  async function setPlan(id, planKey) {
    setErr('');
    try {
      await api(`/api/admin/restaurants/${id}`, { method: 'PATCH', body: { planKey: planKey || null } });
      load(q);
    } catch (e) {
      setErr(errText(e));
    }
  }

  /** Pazarlıklı oran: boş = paketin oranı. Yüzde girilir, bps gider. */
  async function setOverride(id, text) {
    setErr('');
    const raw = String(text).trim();
    let commissionBpsOverride = null;
    if (raw !== '') {
      const n = Number(raw.replace(',', '.'));
      if (!Number.isFinite(n) || n < 0 || n > 100) return setErr('Oran 0 ile 100 arasında olmalı');
      commissionBpsOverride = Math.round(n * 100);
    }
    try {
      await api(`/api/admin/restaurants/${id}`, { method: 'PATCH', body: { commissionBpsOverride } });
      load(q);
    } catch (e) {
      setErr(errText(e));
    }
  }

  async function setStatus(id, subscriptionStatus) {
    setErr('');
    try {
      await api(`/api/admin/restaurants/${id}`, { method: 'PATCH', body: { subscriptionStatus } });
      load(q);
    } catch (e) {
      setErr(errText(e));
    }
  }

  if (err && !list) return <p className="err">{err}</p>;
  if (!list) return <p className="muted">yükleniyor…</p>;

  return (
    <div className="card">
      <h2>Restoranlar ({list.length})</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <input style={{ maxWidth: 280 }} placeholder="ara…" value={q}
          onChange={(e) => { setQ(e.target.value); load(e.target.value); }} />
        <span className="spacer" />
        <span className="muted" style={{ fontSize: 12 }}>
          "Pazarlık %" boşsa paketin oranı geçerlidir; doldurulursa o restoran için paketi EZER.
        </span>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>Restoran</th><th>Ülke</th><th>Paket</th>
              <th style={{ width: 110 }}>Pazarlık %</th><th>Abonelik</th>
              <th>Tahsilat</th><th>Mod</th><th>Personel</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id}>
                <td>
                  {r.name}
                  <div className="muted">{r.slug}</div>
                </td>
                <td>{r.country} · {r.currency}</td>
                <td>
                  <select value={r.planKey || ''} onChange={(e) => setPlan(r.id, e.target.value)}>
                    <option value="">—</option>
                    {plans.map((p) => <option key={p.key} value={p.key}>{p.name}</option>)}
                  </select>
                </td>
                <td>
                  <input
                    defaultValue={r.commissionBpsOverride != null ? (r.commissionBpsOverride / 100).toFixed(2) : ''}
                    placeholder="paket"
                    onBlur={(e) => {
                      const cur = r.commissionBpsOverride != null ? (r.commissionBpsOverride / 100).toFixed(2) : '';
                      if (e.target.value.trim() !== cur) setOverride(r.id, e.target.value);
                    }}
                  />
                </td>
                <td>
                  <select value={r.subscriptionStatus || ''} onChange={(e) => setStatus(r.id, e.target.value)}>
                    {['', 'trialing', 'active', 'past_due', 'canceled'].map((s) => (
                      <option key={s} value={s}>{s || '—'}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <span className={`badge ${r.connectStatus === 'COMPLETED' ? 'ok' : 'warn'}`}>{r.connectStatus}</span>
                </td>
                <td className="muted">{r.orderingMode === 'OPEN_TABLE' ? 'açık hesap' : 'önce ödeme'}</td>
                <td>{r.staffCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {err && <p className="err">{err}</p>}
    </div>
  );
}
